import { Grid } from '@mui/material'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import i18n from 'simple-react-i18n'
import { getSquare } from 'exploitations/utils/AgriUtils'
import { WaterTurnsRestrictionShape } from 'territory/shapes/TerritoryShapes'

const RestictionsDisplay = ({
    restrictions = [],
}) => {
    const xRestrictions = useMemo(() => [
        ...restrictions,
        {
            color: '#52D100',
            label: 'Aucune restriction',
            level: 'X',
        },
    ], [restrictions])
    return (
        <Grid container size={12} justifyContent='space-evenly'>
            {xRestrictions.length ? xRestrictions.map(restriction => (
                <Grid key={`restriction_${restriction.level}`}>
                    {getSquare(restriction.color, true)} {restriction.label} ({restriction.level})
                </Grid>
            )) : i18n.noRestrictions}
        </Grid>
    )
}

RestictionsDisplay.propTypes = {
    restrictions: PropTypes.arrayOf(WaterTurnsRestrictionShape),
}

export default RestictionsDisplay